import MainModal from '@/common/components/base/modal/Modal';
import { MainModalProps } from '@/common/components/base/modal/Modal.type';
import Button from '@/common/components/base/button/Button.tsx';
import { Box, Flex } from 'styled-system/jsx';
import Typography from '@/common/components/base/typography/Typography';
import LoadingButton from '@/common/components/base/button/loadingButton';
import GreenButton from '@/common/assets/icons/greenCheckIcon.svg?react';

export default ({
  closeModal,
  open,
  onSubmit,
  loading,
}: MainModalProps & { onSubmit: () => void; loading: boolean }) => {
  return (
    <MainModal closeModal={loading ? () => {} : closeModal} open={open}>
      <SignatureConfirmationModal
        closeModal={closeModal}
        onSubmit={onSubmit}
        loading={loading}
      />
    </MainModal>
  );
};
export const SignatureConfirmationModal = ({
  closeModal,
  onSubmit,
  loading,
}: Pick<MainModalProps, 'closeModal'> & {
  onSubmit: () => void;
  loading: boolean;
}) => {
  return (
    <Box>
      <Flex justifyContent="center" alignItems="center" mb="1rem">
        <GreenButton />
      </Flex>
      <Typography color="black-1" textAlign="center">
        آیا از ثبت نمونه امضای ترسیم شده مطمئن هستید؟
      </Typography>
      <Typography my="1rem" color="black-3" textStyle="b2" textAlign="center">
        در صورت ثبت امکان ویرایش امضا وجود ندارد{' '}
      </Typography>
      <Flex mb="15px" gap="10px">
        <Button
          fullWidth
          onClick={closeModal}
          variant={'outlined'}
          color="common"
          disabled={loading}
        >
          انصراف
        </Button>
        <LoadingButton
          loading={loading}
          onClick={onSubmit}
          fullWidth
          color="primary"
        >
          ثبت امضا
        </LoadingButton>
      </Flex>
    </Box>
  );
};
